<template>
  <v-dialog
    :value="dialog"
    persistent
    max-width="800"
    @input="$emit('update:dialog', $event)"
  >
    <v-card v-if="dialog" class="tw-flex tw-w-full tw-flex-col">
      <v-icon class="tw-self-end tw-cursor-pointer" color="error" @click="redirect">mdi-close</v-icon>
      <div class="tw-w-full tw-flex tw-p-3 tw-flex-col tw-justify-center tw-text-center">
        <v-icon size="70" color="success">mdi-emoticon-happy-outline</v-icon>
        <h3 class="tw-w-full c-blue-text c-title tw-text-base md:tw-text-xl">Congratulations</h3>
        <p class="c-blue-text tw-text-xl"> Payment successful</p>
        <p class="tw-mt-3 tw-px-4">Your policy is now active.  Your certificate will be sent to your email shortly.
          <br> Reach us on 0730677000 should you have any queries.</p>
      </div>
      <div class="tw-w-full tw-flex tw-text-center md:tw-text-left">
        <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
          <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
            <img src="/images/icons/car-g.png" class="tw-h-16 lg:tw-h-auto tw-mr-2 lg:tw-mr-4" alt="car icon">
            <div class="tw-px-2 md:tw-px-8">
              <h3 class="c-gray-text c-title tw-text-sm md:tw-text-xl">{{ policy.type_of_cover }}</h3>
              <p class="c-blue-text tw-text-sm tw-mt-2 md:tw-mt-4">{{ policy.vehicles[0].make }} {{ policy.vehicles[0].model.toUpperCase() }} , {{ policy.vehicles[0].registration_number.toUpperCase() }}</p>
            </div>
          </div>
          <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400 tw-mt-5 md:tw-mt-0">
            <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl">Policy Number:</h3>
            <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl">{{ policy.policy_number }}</h3>
          </div>
        </div>
      </div>

      <div class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4">
        <div class="tw-w-full tw-flex">
          <div class="tw-w-full tw-flex tw-justify-center md:tw-flex-no-wrap tw-flex-wrap tw-text-center md:tw-text-left tw-items-center tw-my-5 md:tw-my-8">
            <div class="tw-w-full md:tw-w-1/2 tw-flex tw-flex-wrap md:tw-px-10">
              <div class="tw-w-full tw-flex tw-justify-between tw-px-1 md:tw-px-6">
                <p class="c-light-blue-text tw-text-base">Start Date</p>
                <p class="c-gray-text twty-text-base">{{ policy.policy_start_date }}</p>
              </div>
              <div class="tw-w-full tw-flex tw-justify-between tw-px-1 md:tw-px-6">
                <p class="c-yellow-text tw-text-base">Renewal Date</p>
                <p class="c-gray-text twty-text-base">{{ policy.policy_renewal_date }}</p>
              </div>
            </div>
            <div class="tw-w-full md:tw-w-1/2 tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">Total Premium Amount</h4>
              <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ policy.total_premium_amount | formatNum }}</h3>
            </div>
          </div>
        </div>
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="redirect"
        >
          Done
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import helpers from '@/utils/helpers';

export default {
  name: 'NewPolicyPrompt',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    policy: {
      type: Object,
      default: () => ({}),
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
  methods: {
    redirect() {
      this.$emit('update:dialog', false);
      this.$router.push({ name: 'MyPolicies' });
    },
  },
};
</script>
